module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_9006.bb555e48.png";